var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"podium"},_vm._l((_vm.users),function(user,index){return _c('div',{key:user.id,staticClass:"user"},[_c('MigrationAvatar',{attrs:{"user":user,"position":index}}),_c('div',{staticClass:"medal"},[_vm._v(_vm._s(["🥇", "🥈", "🥉"][index]))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }